/* tslint:disable */
/* eslint-disable */
/**
 * Committee Management API
 * The Law Society Committee Management Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { CommitteeMemberAttendanceViewResponse } from '../models';
import { CommitteeMemberDetailIEnumerableResponse } from '../models';
import { CommitteeMemberIEnumerableResponse } from '../models';
import { CommitteeMemberRequest } from '../models';
import { CommitteeMemberRequestWithNote } from '../models';
import { CommitteeMemberResponse } from '../models';
import { CommitteeRequest } from '../models';
import { CommitteeViewIEnumerableResponse } from '../models';
import { CommitteeViewResponse } from '../models';
import { FastTrackRequest } from '../models';
import { MeetingIEnumerableResponse } from '../models';
import { MeetingMemberAttendanceRequest } from '../models';
import { MeetingMemberIEnumerableResponse } from '../models';
import { MeetingRequest } from '../models';
import { MeetingWithFilesResponse } from '../models';
import { Request } from '../models';
import { YearIEnumerableResponse } from '../models';
import { YearResponse } from '../models';
/**
 * CommitteeApi - axios parameter creator
 * @export
 */
export const CommitteeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a meeting
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete: async (yearId: number, committeeId: number, meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete.');
            }
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete.');
            }
            const localVarPath = `/api/v1/Committee/DeleteMeeting/{yearId}/{committeeId}/{meetingId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetComingYearGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/GetComingYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committee
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeCommitteeIdGet: async (committeeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetCommitteeCommitteeIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetCommittee/{committeeId}`
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA CMA High Admin ReadOnly | Returns Committee Meetings by yearId, committeeId and memberId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet: async (yearId: number, committeeId: number, memberId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet.');
            }
            // verify required parameter 'memberId' is not null or undefined
            if (memberId === null || memberId === undefined) {
                throw new RequiredError('memberId','Required parameter memberId was null or undefined when calling apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetCommitteeMeetingAttendanceForMember/{yearId}/{committeeId}/{memberId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet: async (yearId: number, committeeId: number, memberId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet.');
            }
            // verify required parameter 'memberId' is not null or undefined
            if (memberId === null || memberId === undefined) {
                throw new RequiredError('memberId','Required parameter memberId was null or undefined when calling apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetCommitteeMember/{yearId}/{committeeId}/{memberId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA ALL | Returns Committees
         * @param {number} yearId 
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet: async (yearId: number, lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet.');
            }
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetCommitteeMembersForMember/{yearId}/{lawId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet: async (yearId: number, committeeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetCommitteeMembers/{yearId}/{committeeId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCurrentYearGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/GetCurrentYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetLastYearGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/GetLastYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meeting Members by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet: async (yearId: number, committeeId: number, meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetMeetingMembers/{yearId}/{committeeId}/{meetingId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Meeting by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet: async (yearId: number, committeeId: number, meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetMeeting/{yearId}/{committeeId}/{meetingId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingsYearIdCommitteeIdGet: async (yearId: number, committeeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetMeetingsYearIdCommitteeIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1CommitteeGetMeetingsYearIdCommitteeIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetMeetings/{yearId}/{committeeId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetYearYearIdGet: async (yearId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1CommitteeGetYearYearIdGet.');
            }
            const localVarPath = `/api/v1/Committee/GetYear/{yearId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetYearsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/GetYears`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteeMemberPost: async (body?: CommitteeMemberRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveCommitteeMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequestWithNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteeMemberWithNotePost: async (body?: CommitteeMemberRequestWithNote, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveCommitteeMemberWithNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High | Save a committee
         * @param {CommitteeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteePost: async (body?: CommitteeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveCommittee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Fast Track Committee Members
         * @param {FastTrackRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveFastTrackCommitteeMembersPost: async (body?: FastTrackRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveFastTrackCommitteeMembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting Members' Attendance
         * @param {MeetingMemberAttendanceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveMeetingMemberAttendancePost: async (body?: MeetingMemberAttendanceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveMeetingMemberAttendance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting
         * @param {MeetingRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveMeetingPost: async (body?: MeetingRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SaveMeeting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSearchCommitteesPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Committee/SearchCommittees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommitteeApi - functional programming interface
 * @export
 */
export const CommitteeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a meeting
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId: number, committeeId: number, meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId, committeeId, meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetComingYearGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetComingYearGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committee
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA CMA High Admin ReadOnly | Returns Committee Meetings by yearId, committeeId and memberId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeMemberAttendanceViewResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeMemberResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA ALL | Returns Committees
         * @param {number} yearId 
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId: number, lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeMemberDetailIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId, lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeMemberIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId, committeeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetCurrentYearGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetCurrentYearGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetLastYearGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetLastYearGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meeting Members by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingMemberIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Meeting by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingWithFilesResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId, committeeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetYearYearIdGet(yearId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetYearYearIdGet(yearId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeGetYearsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeGetYearsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveCommitteeMemberPost(body?: CommitteeMemberRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveCommitteeMemberPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequestWithNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveCommitteeMemberWithNotePost(body?: CommitteeMemberRequestWithNote, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveCommitteeMemberWithNotePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High | Save a committee
         * @param {CommitteeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveCommitteePost(body?: CommitteeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveCommitteePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Fast Track Committee Members
         * @param {FastTrackRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveFastTrackCommitteeMembersPost(body?: FastTrackRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveFastTrackCommitteeMembersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting Members' Attendance
         * @param {MeetingMemberAttendanceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveMeetingMemberAttendancePost(body?: MeetingMemberAttendanceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveMeetingMemberAttendancePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting
         * @param {MeetingRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSaveMeetingPost(body?: MeetingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSaveMeetingPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommitteeSearchCommitteesPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CommitteeApiAxiosParamCreator(configuration).apiV1CommitteeSearchCommitteesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CommitteeApi - factory interface
 * @export
 */
export const CommitteeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a meeting
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId: number, committeeId: number, meetingId: number, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId, committeeId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetComingYearGet(options?: any): AxiosPromise<YearResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetComingYearGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Returns Committee
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId: number, options?: any): AxiosPromise<CommitteeViewResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA CMA High Admin ReadOnly | Returns Committee Meetings by yearId, committeeId and memberId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any): AxiosPromise<CommitteeMemberAttendanceViewResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any): AxiosPromise<CommitteeMemberResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA ALL | Returns Committees
         * @param {number} yearId 
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId: number, lawId: string, options?: any): AxiosPromise<CommitteeMemberDetailIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId, lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): AxiosPromise<CommitteeMemberIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns year (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetCurrentYearGet(options?: any): AxiosPromise<YearResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetCurrentYearGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetLastYearGet(options?: any): AxiosPromise<YearResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetLastYearGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meeting Members by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): AxiosPromise<MeetingMemberIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly| Returns Committee Meeting by yearId, committeeId and meetingId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): AxiosPromise<MeetingWithFilesResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): AxiosPromise<MeetingIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {number} yearId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetYearYearIdGet(yearId: number, options?: any): AxiosPromise<YearIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetYearYearIdGet(yearId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeGetYearsGet(options?: any): AxiosPromise<YearIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeGetYearsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteeMemberPost(body?: CommitteeMemberRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveCommitteeMemberPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Returns Save a Committee member
         * @param {CommitteeMemberRequestWithNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteeMemberWithNotePost(body?: CommitteeMemberRequestWithNote, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveCommitteeMemberWithNotePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High | Save a committee
         * @param {CommitteeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveCommitteePost(body?: CommitteeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveCommitteePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save Fast Track Committee Members
         * @param {FastTrackRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveFastTrackCommitteeMembersPost(body?: FastTrackRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveFastTrackCommitteeMembersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting Members' Attendance
         * @param {MeetingMemberAttendanceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveMeetingMemberAttendancePost(body?: MeetingMemberAttendanceRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveMeetingMemberAttendancePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save a Meeting
         * @param {MeetingRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSaveMeetingPost(body?: MeetingRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSaveMeetingPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommitteeSearchCommitteesPost(body?: Request, options?: any): AxiosPromise<CommitteeViewIEnumerableResponse> {
            return CommitteeApiFp(configuration).apiV1CommitteeSearchCommitteesPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommitteeApi - object-oriented interface
 * @export
 * @class CommitteeApi
 * @extends {BaseAPI}
 */
export class CommitteeApi extends BaseAPI {
    /**
     * 
     * @summary CMA High Admin | Delete a meeting
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId: number, committeeId: number, meetingId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeDeleteMeetingYearIdCommitteeIdMeetingIdDelete(yearId, committeeId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns year (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetComingYearGet(options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetComingYearGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Returns Committee
     * @param {number} committeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCommitteeCommitteeIdGet(committeeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA CMA High Admin ReadOnly | Returns Committee Meetings by yearId, committeeId and memberId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCommitteeMeetingAttendanceForMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId: number, committeeId: number, memberId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCommitteeMemberYearIdCommitteeIdMemberIdGet(yearId, committeeId, memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA ALL | Returns Committees
     * @param {number} yearId 
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId: number, lawId: string, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCommitteeMembersForMemberYearIdLawIdGet(yearId, lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly| Returns Committee Members by yearId and committeeId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCommitteeMembersYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns year (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetCurrentYearGet(options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetCurrentYearGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns years
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetLastYearGet(options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetLastYearGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly | Returns Committee Meeting Members by yearId, committeeId and meetingId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetMeetingMembersYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly| Returns Committee Meeting by yearId, committeeId and meetingId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetMeetingYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetMeetingsYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns years
     * @param {number} yearId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetYearYearIdGet(yearId: number, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetYearYearIdGet(yearId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns years
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeGetYearsGet(options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeGetYearsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Returns Save a Committee member
     * @param {CommitteeMemberRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveCommitteeMemberPost(body?: CommitteeMemberRequest, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveCommitteeMemberPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Returns Save a Committee member
     * @param {CommitteeMemberRequestWithNote} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveCommitteeMemberWithNotePost(body?: CommitteeMemberRequestWithNote, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveCommitteeMemberWithNotePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High | Save a committee
     * @param {CommitteeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveCommitteePost(body?: CommitteeRequest, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveCommitteePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save Fast Track Committee Members
     * @param {FastTrackRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveFastTrackCommitteeMembersPost(body?: FastTrackRequest, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveFastTrackCommitteeMembersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save a Meeting Members' Attendance
     * @param {MeetingMemberAttendanceRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveMeetingMemberAttendancePost(body?: MeetingMemberAttendanceRequest, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveMeetingMemberAttendancePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save a Meeting
     * @param {MeetingRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSaveMeetingPost(body?: MeetingRequest, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSaveMeetingPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Committees
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitteeApi
     */
    public apiV1CommitteeSearchCommitteesPost(body?: Request, options?: any) {
        return CommitteeApiFp(this.configuration).apiV1CommitteeSearchCommitteesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
